/* eslint-disable no-shadow */
import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes, { any } from 'prop-types';

import Img from '../../../components/Img';
import Description from '../../../components/text/Description';
import MessageButton from '../../../components/cards/PlayerCard/ListViewComponents/MessageButton';
import PopOverMenu from '../../../components/PopOverMenu';
import PlayerRatingV2 from '../PlayerRatingV2';
import { gameTypes } from '../../../utils/constants';
import AvatarV2 from '../../../components/cards/PlayerCard/ListViewComponents/AvatarV2';
import { bucketWildcardTags as wildcardTags, sportTypeIds } from '../../../utils/eventConstants';
import { isPlayerCheckedIntoDraw } from '../../../utils/events';

import { NOTIFICATIONS_SHOW_SUCCESS_TOAST } from '../../../actions/actionTypes/notification-action-types';
import { getPlayerPosition } from '../../../utils';

import styles from './playersTab.scss';

const AllPlayersItemV3 = (props) => {
    const {
        selected,
        player,
        showMessage,
        onMessageClick,
        showMenuOptions,
        menuOptions,
        onMenuSelected,
        sportTypeId,
        showHighSchoolName,
        drawsDict,
        isOneDivisionSelected,
        isFlexLeagueEvent,
        'data-testid': dataTestId,
    } = props;
    const dispatch = useDispatch();

    const description = [
        ...(player.acceptanceListWildcardStateId ? [wildcardTags[player.acceptanceListWildcardStateId]] : []),
        player.gender,
        showHighSchoolName && player.highSchool ? player.highSchool : player.location?.display,
    ];

    const copyToClipboard = (e, text) => {
        e.stopPropagation();
        navigator.clipboard.writeText(text);
        dispatch({
            type: NOTIFICATIONS_SHOW_SUCCESS_TOAST,
            message: 'Copied...',
        });
    };

    const getDrawName = (draw) => {
        const drawsDictObj = drawsDict[draw.id];
        if (drawsDictObj?.isChildDraw) {
            return `${drawsDict[drawsDictObj.parentDrawId]?.name}, ${draw.name}`;
        }

        return draw.name;
    };

    const filteredDivisions = player.divisions?.filter((div) => !div.isEventEntryFeeDivision);
    const positions = filteredDivisions?.map(div => getPlayerPosition(div));

    return (
        <div className={`item ${selected ? 'selected' : ''} ${styles.allPlayersItem}`} onClick={() => { props.togglePlayerSelect(player.memberId); }} data-testid={dataTestId}>
            <div className="checkbox-wrapper">
                <div className={`checkbox-check`}><Img src="/img/icons/checkmark-icon.svg" /></div>
            </div>
            <div className="row">
                <div className={`col-md-5 d-flex aic`}>
                    <div className="row flex-grow">
                        <div className={`col-md-3 d-flex aic`}>
                            <AvatarV2
                                playerImages={player.playerProfileImages}
                                player={player}
                                className={styles.avatar}
                                data-testid={dataTestId && `${dataTestId}.avatar`}
                            />
                            <div className="player-details">
                                <div className="name text-dark" data-testid={dataTestId && `${dataTestId}.name`}>{player.firstName} {player.lastName}</div>
                                <div className="location text-normal text-gray">
                                    <Description desc={description} data-testid={dataTestId && `${dataTestId}.description`} />
                                </div>
                            </div>
                        </div>
                        <PlayerRatingV2
                            {...props}
                            sportTypeId={sportTypeId}
                            ratingType={gameTypes.SINGLES}
                            data-testid={dataTestId && `${dataTestId}.singles-rating`}
                        />
                        <PlayerRatingV2
                            {...props}
                            sportTypeId={sportTypeId}
                            ratingType={gameTypes.DOUBLES}
                            data-testid={dataTestId && `${dataTestId}.doubles-rating`}
                        />
                        <div className="col-md-1 d-flex aic">
                            <div className="player-details">
                                <div className="name text-dark" data-testid={dataTestId && `${dataTestId}.age`}>
                                    {player.age}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 d-flex aic overflow-hidden">
                            <div className="player-details overflow-hidden">
                                {!!player.email && (
                                    <div className="name text-dark clickable ellipsis" title={player.email} onClick={(e) => copyToClipboard(e, player.email)} data-testid={dataTestId && `${dataTestId}.email`}>
                                        {player.email}
                                    </div>
                                )}
                                {!!player.phone && (
                                    <div className="location text-dark clickable ellipsis" title={player.phone} onClick={(e) => copyToClipboard(e, player.phone)} data-testid={dataTestId && `${dataTestId}.phone`}>
                                        {player.phone}
                                    </div>
                                )}
                                <span className={`${styles.sms}`}>
                                    {player.smsOptIn && <span className={`${styles.on}`} data-testid={dataTestId && `${dataTestId}.sms-on`}>SMS ON</span>}
                                    {!player.smsOptIn && <span className={`${styles.off}`} data-testid={dataTestId && `${dataTestId}.sms-off`}>SMS OFF</span>}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                {isOneDivisionSelected ? (
                    <div className="col-md-1 draws-list d-flex aic" title={player.regStatus} data-testid={dataTestId && `${dataTestId}.reg-status`}>
                        {player.regStatus || 'Main'}
                    </div>
                ) : (
                    <div className="col-md-1 draws-list d-flex flex-column jcc" title={player.regStatus}>
                        {positions.map((pos, i) => (
                            <div className={`values ellipsis`} title={pos?.bucket} key={`${pos?.bucket}-${i}`} data-testid={dataTestId && `${dataTestId}.position-${i}`}>
                                {pos?.bucket}
                            </div>
                        ))}
                    </div>
                )}
                {isFlexLeagueEvent && (
                    <div className={`col-md-1 d-flex aic`}>
                        <div className="player-details overflow-hidden" title={player.homeCourt}>
                            <div className="name text-dark ellipsis" data-testid={dataTestId && `${dataTestId}.home-court`}>
                                {player.homeCourt?.split(',')[0] || ''}
                            </div>
                            <div className="location text-normal text-gray" data-testid={dataTestId && `${dataTestId}.home-court-detail`}>
                                {player.homeCourt?.split(',').slice(1).join(',').trim() || ''}
                            </div>
                        </div>
                    </div>
                )}
                <div className={`col-md-2 draws-list d-flex flex-column jcc overflow-hidden`}>
                    {filteredDivisions?.length ? (
                        <>
                            {filteredDivisions.map(div => <div key={div.id} title={div.name} className={`overflow-hidden ellipsis`} data-testid={dataTestId && `${dataTestId}.division-${div.id}`}>{div.name}</div>)}
                        </>
                    ) : <span className="text-error text-medium" data-testid={dataTestId && `${dataTestId}.not-in-division`}>Not in division</span>}
                </div>
                <div className={`col-md-2 draws-list d-flex flex-column jcc overflow-hidden`}>
                    {player.draws?.length ? (
                        <>
                            {player.draws.map(draw => (
                                <div key={draw.id} title={getDrawName(draw)} className={`overflow-hidden ellipsis`} data-testid={dataTestId && `${dataTestId}.draw-${draw.id}`}>
                                    {isPlayerCheckedIntoDraw(player, draw.drawId) && <span className="utr-icon icon-check-mark-green mr4 checkin-mark" title="Player checked in" />}
                                    {getDrawName(draw)}
                                </div>
                            ))}
                        </>
                    ) : <span className="text-error text-medium" data-testid={dataTestId && `${dataTestId}.not-in-draw`}>Not in draw</span>}
                </div>
                <div className="col-md-1 d-flex aic jcfe">
                    {showMessage && <MessageButton onMessageClick={onMessageClick} data-testid={dataTestId && `${dataTestId}.message-btn`} />}
                    {showMenuOptions && !!menuOptions.length && (
                        <PopOverMenu
                            horizontalEllipsis={false}
                            menuItems={menuOptions}
                            onSelected={onMenuSelected}
                            data-testid={dataTestId && `${dataTestId}.menu`}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

AllPlayersItemV3.propTypes = {
    selected: PropTypes.bool,
    player: PropTypes.objectOf(any).isRequired,
    showMessage: PropTypes.bool,
    onMessageClick: PropTypes.func,
    showMenuOptions: PropTypes.bool,
    menuOptions: PropTypes.arrayOf(any),
    onMenuSelected: PropTypes.func,
    sportTypeId: PropTypes.number,
    showHighSchoolName: PropTypes.bool,
    togglePlayerSelect: PropTypes.func,
    drawsDict: PropTypes.objectOf(any).isRequired,
    isOneDivisionSelected: PropTypes.bool,
    isFlexLeagueEvent: PropTypes.bool,
    'data-testid': PropTypes.string,
};

AllPlayersItemV3.defaultProps = {
    selected: false,
    showMessage: false,
    onMessageClick: () => { },
    showMenuOptions: false,
    menuOptions: [],
    onMenuSelected: () => { },
    sportTypeId: sportTypeIds.TENNIS,
    showHighSchoolName: false,
    togglePlayerSelect: () => { },
    isOneDivisionSelected: false,
    isFlexLeagueEvent: false,
    'data-testid': undefined,
};

export default React.memo(AllPlayersItemV3);
